module.exports = __webpack_public_path__ + "static/cube20-d84dc74cc938f874cab793f16d94d728.svg";